import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex flex-col space-y-4 mb-4" }
const _hoisted_3 = { class: "flex w-full items-center" }
const _hoisted_4 = { class: "mb-0 ml-2 mr-auto" }
const _hoisted_5 = {
  key: 1,
  class: "flex space-x-3 items-center"
}
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = {
  key: 2,
  class: "ml-2"
}
const _hoisted_8 = {
  key: 3,
  class: "ml-2"
}
const _hoisted_9 = {
  style: {"width":"24px","fill":"currentColor"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", { d: "M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "w-full flex" }
const _hoisted_13 = {
  style: {"width":"24px","fill":"currentColor"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", { d: "M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "edit", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "close", -1)
const _hoisted_19 = { class: "mb-8 flex items-center space-x-8" }
const _hoisted_20 = { class: "w-1/3" }
const _hoisted_21 = { class: "mb-8" }
const _hoisted_22 = { class: "error-msg" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "grid lg:grid-cols-2 lg:gap-6 gap-4 grid-cols-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_CloudSaveStatus = _resolveComponent("CloudSaveStatus")!
  const _component_IntegrationSwitch = _resolveComponent("IntegrationSwitch")!
  const _component_PublishedOnClassroom = _resolveComponent("PublishedOnClassroom")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_FileNode = _resolveComponent("FileNode")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_SchedulePublishDialog = _resolveComponent("SchedulePublishDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Btn, {
          variant: 'icon',
          outline: true,
          class: "-ml-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: "material-icons-outlined",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeEditor')))
            }, " close")
          ]),
          _: 1
        }),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("course_tree.announcement_editor_title")), 1),
        (_ctx.showAutoSaveIndicator)
          ? (_openBlock(), _createBlock(_component_CloudSaveStatus, {
              key: 0,
              saving: _ctx.saving,
              hadError: _ctx.savingError,
              class: "mt-1 mr-6"
            }, null, 8, ["saving", "hadError"]))
          : _createCommentVNode("", true),
        (_ctx.modelValue.state === _ctx.AnnouncementNodeState.DRAFT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("course_tree.draft")), 1),
              _createVNode(_component_Btn, {
                disabled: _ctx.blockingSaving,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPublish()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("course_tree.publish_announcement")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.publishOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_Btn, {
                outline: _ctx.modelValue.state === _ctx.AnnouncementNodeState.DRAFT,
                disabled: _ctx.blockingSaving,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSave()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.modelValue.state === _ctx.AnnouncementNodeState.DRAFT
								? _ctx.$t("course_tree.save_draft")
								: _ctx.$t("course_tree.save")), 1)
                ]),
                _: 1
              }, 8, ["outline", "disabled"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.modelValue.state === _ctx.AnnouncementNodeState.DRAFT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_Btn, {
                variant: 'icon',
                outline: true,
                class: "icon-btn-primary",
                disabled: _ctx.blockingSaving,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showScheduleDialog = true)),
                tooltip: _ctx.$t('course_tree.schedule')
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                ]),
                _: 1
              }, 8, ["disabled", "tooltip"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (
						_ctx.showClassroomIntegrationSwitch &&
						_ctx.modelValue.state === _ctx.AnnouncementNodeState.DRAFT
					)
          ? (_openBlock(), _createBlock(_component_IntegrationSwitch, {
              key: 0,
              class: "ml-auto",
              modelValue: _ctx.publishToClassroom,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.publishToClassroom) = $event))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.hasGoogleClassroomTwin)
          ? (_openBlock(), _createBlock(_component_PublishedOnClassroom, {
              key: 1,
              class: "banner-success rounded px-2 ml-auto",
              "remote-object-url": _ctx.googleClassroomAnnouncementTwin?.data.alternateLink
            }, null, 8, ["remote-object-url"]))
          : _createCommentVNode("", true),
        (_ctx.canceledScheduledPublish)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([[
						(_ctx.showClassroomIntegrationSwitch &&
							_ctx.modelValue.state === _ctx.AnnouncementNodeState.DRAFT) ||
						_ctx.hasGoogleClassroomTwin
							? 'ml-12'
							: 'ml-auto',
					], "banner banner-light py-1.5 px-1.5 text-muted"])
            }, _toDisplayString(_ctx.$t("course_tree.save_to_cancel_scheduled_publish")), 3))
          : _createCommentVNode("", true),
        (
						_ctx.modelValue.state === _ctx.AnnouncementNodeState.DRAFT &&
						_ctx.modelValue.schedule_publish_at
					)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass([[
						(_ctx.showClassroomIntegrationSwitch &&
							_ctx.modelValue.state === _ctx.AnnouncementNodeState.DRAFT) ||
						_ctx.hasGoogleClassroomTwin
							? 'ml-12'
							: 'ml-auto',
					], "banner banner-light py-0.5 pr-1"])
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15)),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("course_tree.scheduled_for")) + " ", 1),
                _createVNode(_component_Timestamp, {
                  value: _ctx.modelValue.schedule_publish_at
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_Btn, {
                  variant: 'icon',
                  outline: true,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showScheduleDialog = true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createVNode(_component_Btn, {
                  variant: 'icon',
                  outline: true,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSchedule(null)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_Dropdown, {
          loading: _ctx.loadingTopics,
          options: _ctx.topicsAsOptions,
          modelValue: _ctx.modelValue.parent_id,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.onParentChange($event)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("course_tree.topic_label")), 1)
          ]),
          _: 1
        }, 8, ["loading", "options", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_TextEditor, {
        modelValue: _ctx.modelValue.body,
        fixedLabel: true,
        onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onBlur())),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.onNodeChange('body', $event)))
      }, _createSlots({
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("course_tree.announcement_body")) + " ", 1)
        ]),
        _: 2
      }, [
        (_ctx.v$.modelValue.body.$errors.length > 0)
          ? {
              name: "errors",
              fn: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.body.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("validation_errors.course_tree.announcement." + error.$uid)), 1)
                  ]))
                }), 128))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue"])
    ]),
    (_ctx.allowChildren)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t("course_tree.announcement_attachments")), 1),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileChildren, (fileNode) => {
              return (_openBlock(), _createElementBlock("div", {
                key: fileNode.id
              }, [
                _createVNode(_component_FileNode, {
                  onDeleteNode: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('deleteNode', $event))),
                  isDraggable: false,
                  canEdit: true,
                  node: fileNode
                }, null, 8, ["node"])
              ]))
            }), 128)),
            _createVNode(_component_FileUpload, {
              uploadProgress: _ctx.attachmentUploadProgress,
              uploading: _ctx.creatingAttachment,
              modelValue: _ctx.attachmentProxy,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.attachmentProxy) = $event)),
              autoUpload: true,
              clearImmediately: true
            }, null, 8, ["uploadProgress", "uploading", "modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_SchedulePublishDialog, {
      onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showScheduleDialog = false)),
      onConfirm: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSchedule($event))),
      visible: _ctx.showScheduleDialog,
      initialValue: _ctx.modelValue.schedule_publish_at
    }, null, 8, ["visible", "initialValue"])
  ]))
}